module.exports = __webpack_public_path__ + "img/3.15c70771.png";